import React, { useContext, useEffect, useState, Fragment } from "react";
import { Form,FormGroup,Input,Container } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
//import WorkOrderStore from "../../../../app/stores/workorderStore";
import { INote } from "../../../../app/models/note";
import { IClientdocument } from "../../../../app/models/clientdocument";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FileSaver from 'file-saver';
import '../../../../app/slider.css'
import { saveAs } from 'file-saver';

import { Image, Icon, Header, Divider, Label, ButtonContent } from "semantic-ui-react";
import { Button } from 'semantic-ui-react'

import axios from "axios";

import config from '../../../../app/api/apiconfig';
import Axios from 'axios'
//
import oneOrderStore from "../../../../app/stores/oneOrderStore";
//import WorkOrderStore from "../../../../app/stores/workorderStore";

const baseURL = config.app.baseUrl
const thisdlphotourl = baseURL + "CP/Photo/downloadPhotos"
const azuremediaurl = config.app.getazuremediaUrl
const azuremediageturl = azuremediaurl + "getFilesForClient"
const downloadazuremediaurl = config.app.downloadazuremediaUrl
const downloadazuremediatoken = config.app.downloadazureToken

interface IProps {}

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  draggable: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  adaptiveWidth: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

//  axios.defaults.baseURL = ""



const WorkOrderDocumentGrid: React.FC<IProps> = props => {
  const workorderStore = useContext(oneOrderStore);
  //const workorderStore = useContext(WorkOrderStore);
  const { selectedWorkOrder: workorder } = workorderStore;
  const [jobdocdata,setJobdocData] = useState();
  const [jobnumdata,setJobnumData] = useState();

  findClientdocsByJobNumber(workorder.JobNo);

  //get files
  async function findClientdocsByJobNumber(jobNumber) {
    console.log(jobNumber != jobnumdata)
    if (jobNumber != null && jobNumber != jobnumdata) {
      let posturl = azuremediageturl + "?jobNumber=" + jobNumber.toUpperCase()
      //let posturl = azuremediaurl + "getFiles?jobNumber=" + jobNumber.toUpperCase()
      console.log(posturl)
      await Axios.get(posturl)
      .then(response => {
         setJobdocData(response.data)
         setJobnumData(jobNumber)
         console.log('getfiles', response.data.length, response.data)
      })
    }
  }

  const showDocument = (docs: IClientdocument[]) => {
    console.log('docs:',docs)
    if (docs != null && docs.length > 0) {
      var doclist = docs.map(item => (
      <Container>
        <Fragment>{'Name:'+decodeURIComponent(item.jobnumber).substring(item.jobnumber.indexOf("/")+1).replace('clientvisible','') + ' '} </Fragment>
        <br /><div style={{ height : '35px'}}>{'Posted:' + item.modifiedOn + ' '} 
        
        <Button style={{ padding: '5px 18px', float:'right' }}
         href={ downloadazuremediaurl + (item.jobnumber) + '' + downloadazuremediatoken}>Download</Button>
         </div>
      </Container>
        
      ));
      return doclist;
    }
    else{
      
      return 'No Document';
    }
    
  };


  useEffect(() => {
    if (workorder != null && workorder.JobNo != null) {
      findClientdocsByJobNumber(workorder.JobNo);
    }
  });

  return (
    <div
      className="ag-theme-material"
      style={{ height: "300px", width: "100%" }}
    >
      <div>{
      showDocument(jobdocdata)
      }</div>
    </div>
  );
};


export default observer(WorkOrderDocumentGrid);